import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {buildFormControlsFromSchema} from '@catuiform/shared/form-builder';

const componentBaseName = 'json-schema-form';
const selectorName = `cat-${componentBaseName}`;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-json-schema-form',
  templateUrl: './json-schema-form.component.html',
  styleUrls: ['./json-schema-form.component.scss'],
})
export class JsonSchemaFormComponent implements OnInit, OnChanges {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() schema: any;
  @Input() uiSchema: any;
  @Input() formData: any;
  @Input() onSubmit = new EventEmitter();

  @ViewChild('widgetContainer', {read: ViewContainerRef})
  widgetContainer: ViewContainerRef;

  dynamicForm: FormGroup;
  formKeys: string[];

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateForm();
  }

  private updateForm() {
    if (this.schema && Object.keys(this.schema).length > 0 && this.formData) {
      const formControls = buildFormControlsFromSchema(this.formBuilder, this.schema, this.formData);
      this.formKeys = Object.keys(formControls);
      this.dynamicForm = this.formBuilder.group(formControls);
    }
  }

  ngOnInit() {
    this.dynamicForm = this.formBuilder.group({});
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-form/components/json-schema-form/json-schema-form.component.ts